import React from 'react';
import PropTypes from 'prop-types';
import { resize } from '../../utils/calculate';

const Disclaimer = props => {
  const { content } = props;
  React.useEffect(() => {
    resize();
  });

  return (
    <div className="disclaimer" id="disclaimer">
      {content}
    </div>
  );
};

Disclaimer.propTypes = {
  content: PropTypes.string,
};

export default Disclaimer;
